<template>
  <div id="zgh">
    <TopList :navList="navList" @setType="setType"></TopList>
    <Tickets></Tickets>
  </div>
</template>

<script>
import TopList from "../../components/topList";
import Tickets from "./components/tickets.vue";
export default {
  name: "index",
  components: {
    TopList,
    Tickets,
  },
  data() {
    return {
      navList: ["我的门票"],
    };
  },
  methods: {
    setType(e) {
      console.log(e);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
